import { useDepartmentText } from 'model/DepartmentTerminology';
import DashboardLayout from 'layouts/dashboard/DashboardLayout';
import DepartmentTable from 'components/tables/data/department/DepartmentTable';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

/**
 * Page used to list departments.
 *
 */
export default function DepartmentsPage() {
  const departmentText = useDepartmentText();
  const [searchParams, setSearchParams] = useSearchParams();

  const [initialFilters] = useState(() => {
    const filters: Record<string, any> = {};

    if (searchParams.has('organizationId')) {
      filters['organization.organizationId'] = {
        filter: [searchParams.get('organizationId')],
      };
    }

    return filters;
  });

  useEffect(() => {
    setSearchParams(
      (params) => {
        params.delete('organizationId');
        return params;
      },
      { replace: true }
    );
  }, []);

  return (
    <DashboardLayout breadcrumbs={[{ title: departmentText('Položky úrovne', 'Strediská') }]} height="screen">
      <DepartmentTable initialFilters={initialFilters} />
    </DashboardLayout>
  );
}
